export default __webpack_public_path__ + "static/media/Mercenary's Bracers of the Untamed.e64ca59b.jpg";